import { createReducer, MetaReducer, on } from '@ngrx/store';
import {
    IMaintenanceComponent,
    IMaintenanceFailedTest,
    IMaintenanceLink,
    IMaintenanceModeContext,
    IMaintenanceScheduleItem,
    IMaintenanceTaskCompleted
} from '../../../../model/maintenance';
import { IMaintenanceContext } from './../../../../model/maintenance';
import MaintenanceActions from './maintenance.action-types';
export const maintenanceFeatureKey = 'maintenance';

export interface MaintenanceState {
    maintenanceContext: IMaintenanceContext;
    maintenanceModeContext: IMaintenanceModeContext;
    maintenanceLinks: IMaintenanceLink[];
    maintenanceCommands: string[];
    maintenanceFailedTests: IMaintenanceFailedTest[];
    maintenanceComponents: IMaintenanceComponent[];
    maintenanceSchedule: IMaintenanceScheduleItem[];
    maintenanceTasksCompleted: IMaintenanceTaskCompleted[];
}

export const initialMaintenanceState: MaintenanceState = {
    maintenanceContext: {
        state: '',
        stateName: '',
        messages: [],
        commands: [],
        inSelectionMenu: false
    },
    maintenanceModeContext: {
        locationContext: {
            station: '',
            terminal: '',
            centerlineGroup: '',
            centerline: ''
        },
        inMaintenanceMode: false
    },
    maintenanceLinks: [],
    maintenanceCommands: [],
    maintenanceFailedTests: [],
    maintenanceComponents: [],
    maintenanceSchedule: [],
    maintenanceTasksCompleted: []
};

export const metaReducers: MetaReducer<MaintenanceState>[] = [];

export const maintenanceModeContextReducer = createReducer(
    initialMaintenanceState,

    // Maintenance Context
    on(MaintenanceActions.loadMaintenanceContext, (state, action) => {
        return {
            maintenanceContext: action.maintenanceContext,
            maintenanceModeContext: state.maintenanceModeContext,
            maintenanceLinks: state.maintenanceLinks,
            maintenanceCommands: state.maintenanceCommands,
            maintenanceFailedTests: state.maintenanceFailedTests,
            maintenanceComponents: state.maintenanceComponents,
            maintenanceSchedule: state.maintenanceSchedule,
            maintenanceTasksCompleted: state.maintenanceTasksCompleted
        };
    }),

    // Maintenance Mode
    on(MaintenanceActions.loadMaintenanceModeContext, (state, action) => {
        return {
            maintenanceContext: state.maintenanceContext,
            maintenanceModeContext: action.maintenanceModeContext,
            maintenanceLinks: state.maintenanceLinks,
            maintenanceCommands: state.maintenanceCommands,
            maintenanceFailedTests: state.maintenanceFailedTests,
            maintenanceComponents: state.maintenanceComponents,
            maintenanceSchedule: state.maintenanceSchedule,
            maintenanceTasksCompleted: state.maintenanceTasksCompleted
        };
    }),

    // Links
    on(MaintenanceActions.loadMaintenanceLinks, (state, action) => {
        return {
            maintenanceContext: state.maintenanceContext,
            maintenanceModeContext: state.maintenanceModeContext,
            maintenanceLinks: action.maintenanceLinks,
            maintenanceCommands: state.maintenanceCommands,
            maintenanceFailedTests: state.maintenanceFailedTests,
            maintenanceComponents: state.maintenanceComponents,
            maintenanceSchedule: state.maintenanceSchedule,
            maintenanceTasksCompleted: state.maintenanceTasksCompleted
        };
    }),

    // Commands
    on(MaintenanceActions.loadMaintenanceCommands, (state, action) => {
        return {
            maintenanceContext: state.maintenanceContext,
            maintenanceModeContext: state.maintenanceModeContext,
            maintenanceLinks: state.maintenanceLinks,
            maintenanceCommands: action.maintenanceCommands,
            maintenanceFailedTests: state.maintenanceFailedTests,
            maintenanceComponents: state.maintenanceComponents,
            maintenanceSchedule: state.maintenanceSchedule,
            maintenanceTasksCompleted: state.maintenanceTasksCompleted
        };
    }),

    // Failed Tests
    on(MaintenanceActions.loadMaintenanceFailedTests, (state, action) => {
        return {
            maintenanceContext: state.maintenanceContext,
            maintenanceModeContext: state.maintenanceModeContext,
            maintenanceLinks: state.maintenanceLinks,
            maintenanceCommands: state.maintenanceCommands,
            maintenanceFailedTests: action.maintenanceFailedTests,
            maintenanceComponents: state.maintenanceComponents,
            maintenanceSchedule: state.maintenanceSchedule,
            maintenanceTasksCompleted: state.maintenanceTasksCompleted
        };
    }),

    // Components
    on(MaintenanceActions.loadMaintenanceComponents, (state, action) => {
        return {
            maintenanceContext: state.maintenanceContext,
            maintenanceModeContext: state.maintenanceModeContext,
            maintenanceLinks: state.maintenanceLinks,
            maintenanceCommands: state.maintenanceCommands,
            maintenanceFailedTests: state.maintenanceFailedTests,
            maintenanceComponents: action.maintenanceComponents,
            maintenanceSchedule: state.maintenanceSchedule,
            maintenanceTasksCompleted: state.maintenanceTasksCompleted
        };
    }),

    // Schedule
    on(MaintenanceActions.loadMaintenanceSchedule, (state, action) => {
        return {
            maintenanceContext: state.maintenanceContext,
            maintenanceModeContext: state.maintenanceModeContext,
            maintenanceLinks: state.maintenanceLinks,
            maintenanceCommands: state.maintenanceCommands,
            maintenanceFailedTests: state.maintenanceFailedTests,
            maintenanceComponents: state.maintenanceComponents,
            maintenanceSchedule: action.maintenanceSchedule,
            maintenanceTasksCompleted: state.maintenanceTasksCompleted
        };
    }),

    // Tasks Completed
    on(MaintenanceActions.loadMaintenanceTasksCompleted, (state, action) => {
        return {
            maintenanceContext: state.maintenanceContext,
            maintenanceModeContext: state.maintenanceModeContext,
            maintenanceLinks: state.maintenanceLinks,
            maintenanceCommands: state.maintenanceCommands,
            maintenanceFailedTests: state.maintenanceFailedTests,
            maintenanceComponents: state.maintenanceComponents,
            maintenanceSchedule: state.maintenanceSchedule,
            maintenanceTasksCompleted: action.maintenanceTasksCompleted
        };
    })
);
